import { Component, Input } from '@angular/core'
import { ElementsGroup, ElementsGroupFromJSON } from 'elements-sdk'

@Component({
  selector: 'group-avatar',
  templateUrl: './groupAvatar.component.pug',
  styleUrls: ['./groupAvatar.component.scss'],
})
export class GroupAvatarComponent {
  @Input() group: ElementsGroup

  ngOnChanges () {
    if ('members_preview' in this.group) {
      this.group = ElementsGroupFromJSON(this.group)
    }
  }
}
